import React from 'react';
import T from 'prop-types';
// styles
import Style from 'style-it';
import classnames from 'classnames/bind';
import styles from './CheckBox.mod.css';

const cn = classnames.bind(styles);

const CheckBox = ({
  className = '',
  labelClassName = '',
  boxClassName = '',
  textLabelClassName = '',
  isButtonView,
  label,
  color,
  disabled,
  checked = false,
  ...otherProps
}) => (
  <Style>
    {`${color && 'input:checked + span:first-of-type'} {
            box-shadow: 0 0 0 1px ${color};
            background-color: ${color};
            border-color: ${color};
          }`}
    <div
      className={cn(styles.wrapper, className, {
        disabled
      })}
    >
      <label
        className={cn(styles.label, labelClassName, {
          buttonView: isButtonView,
          checked
        })}
      >
        <input
          type="checkbox"
          className={styles.input}
          disabled={disabled}
          checked={checked}
          {...otherProps}
        />
        <span className={cn(styles.box, boxClassName)} />
        <span className={cn(styles.textLabel, textLabelClassName)}>
          {label}
        </span>
      </label>
    </div>
  </Style>
);

CheckBox.propTypes = {
  label: T.oneOfType([T.string, T.object]).isRequired,
  className: T.string,
  textLabelClassName: T.string,
  labelClassName: T.string,
  boxClassName: T.string,
  color: T.string,
  disabled: T.bool,
  isButtonView: T.bool,
  checked: T.bool
};

export default React.memo(CheckBox);



// WEBPACK FOOTER //
// ./src/components/CheckBox/CheckBox.jsx